// TomSelect non è più importato staticamente: erano ~46 KB di JS più 15 KB di
// CSS su OGNI pagina, mentre le select avanzate esistono solo nella ricerca
// avanzata. Home, liste e schede non ne hanno nessuna.
//
// Chi le usa chiama window.loadTomSelect() e riceve la classe.

let tomSelectPromise = null;

window.loadTomSelect = function () {
    if (!tomSelectPromise) {
        tomSelectPromise = Promise.all([
            import('tom-select'),
            import('tom-select/dist/css/tom-select.bootstrap5.min.css'),
        ]).then(([module]) => {
            const TomSelect = module.default ?? module;
            window.TomSelect = TomSelect;
            return TomSelect;
        });
    }
    return tomSelectPromise;
};
